/**
 * GroupDetails
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useApi2 } from 'containers/Api2/index.js';
import { Alert, Card } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Breadcrumbs from 'components/layout/Breadcrumbs/index.jsx';
import Spinner from 'components/Spinner/index.jsx';
import useGroupTypes from '../useGroupTypes.js';
import messages from './messages.js';
import Settings from './Settings/index.jsx';
import Members from './Members/index.jsx';
import adminParser from '../../adminParser.js';
import ArchiveButton from './ArchiveButton.jsx';
import getPathBase from '../../getPathBase.js';
import CloseGroupButton from './CloseGroupButton.jsx';

function GroupDetails(props) {
  const { setMeta } = props;
  const params = useParams();
  const navigate = useNavigate();
  const { page, id, subPage } = params;
  const group = useApi2({
    url: `sa/groups/${id}`,
    selector: `sa/groups/${page}/${id}`,
    version: 2,
    parser: adminParser,
  });
  const pathBase = getPathBase();
  const groupType = useGroupTypes(group.groupType);
  const basePath = `/${pathBase}/groups/${page}/${id}/`;
  const isAdmin = pathBase === 'admin';
  const components = {
    settings: Settings,
    members: Members,
  };
  const pageTabs = {
    base: basePath,
    tabMessages: messages,
    active: subPage,
    options: Object.keys(components).map((i) => ({ id: i })),
  };
  const hasSubPage = subPage && components[subPage];
  const parts = [
    { href: `/${pathBase}/groups#${groupType ? groupType.id : ''}`, label: messages.groups },
    { label: group.name },
  ];
  if (!isAdmin) {
    parts.splice(0, parts.length - 1);
  }
  const control = isAdmin ? <ArchiveButton group={group} /> : <CloseGroupButton group={group} />;
  useEffect(() => {
    if (!hasSubPage) {
      navigate(`${basePath}settings`, { replace: true });
    }
    setMeta({
      title: [parts.map((p) => p.label).reverse()],
      header: <Breadcrumbs parts={parts} />,
      pageTabs,
      control,
    });
  }, [group.name, subPage]); // eslint-disable-line react-hooks/exhaustive-deps

  const types = Object.values(useGroupTypes()).map((t) => t.id);
  if (!types.includes(page)) {
    return null;
  }
  if (!hasSubPage) {
    return null;
  }
  if (group.error) {
    return <Card className="p-4"><Alert variant="danger">Error</Alert></Card>;
  }
  if (!group || group.loading) {
    return <Spinner />;
  }
  const Component = components[subPage];
  return <Component group={group} />;
}

GroupDetails.propTypes = {
  setMeta: PropTypes.func,
};

export default GroupDetails;
